import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { DashboardPage } from './pages/DashboardPage';
import { CalendarioPage } from './pages/CalendarioPage';
import { SegnalazioniPage } from './pages/SegnalazioniPage';
import { StoricoPage } from './pages/StoricoPage';
import { AbbonamentiPage } from './pages/AbbonamentiPage';
import { SchedaProprietaPage } from './pages/SchedaProprietaPage';
import { ImpostazioniPage } from './pages/ImpostazioniPage';
import { PuliziePage } from './pages/PuliziePage';
import { PuliziaDettaglioPage } from './pages/PuliziaDettaglioPage';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Navigate to="/dashboard" replace data-id="element-3" />} data-id="element-2" />
        <Route path="/dashboard" element={<DashboardPage data-id="element-5" />} data-id="element-4" />
        <Route path="/pulizie" element={<PuliziePage data-id="element-7" />} data-id="element-6" />
        <Route path="/pulizia-dettaglio" element={<PuliziaDettaglioPage data-id="element-9" />} data-id="element-8" />
        <Route path="/calendario" element={<CalendarioPage data-id="element-11" />} data-id="element-10" />
        <Route path="/messaggi" element={<SegnalazioniPage data-id="element-13" />} data-id="element-12" />
        <Route path="/storico" element={<StoricoPage data-id="element-15" />} data-id="element-14" />
        <Route path="/abbonamenti" element={<AbbonamentiPage data-id="element-17" />} data-id="element-16" />
        <Route path="/scheda-proprieta" element={<SchedaProprietaPage data-id="element-19" />} data-id="element-18" />
        <Route path="/impostazioni" element={<ImpostazioniPage data-id="element-21" />} data-id="element-20" />
      </Routes>
    </Router>;
}